/**
 * delete-with-toast: a delete that's awaited before it says anything (CC 0438). Success keeps the screens'
 * existing toast; a refusal (a 409 for a service with bookings, a network error) shows "Couldn't delete …"
 * with the server's own message. The store only drops the row after the server agreed, so the row stays.
 */
import { toast } from "../../shell/toast";

export async function deleteWithToast(run: () => Promise<unknown>, copy: { done: string; doneSub?: string; failed: string }): Promise<boolean> {
  try {
    await run();
    toast({ tone: "warn", title: copy.done, ...(copy.doneSub ? { subtitle: copy.doneSub } : {}) });
    return true;
  } catch (e) {
    toast({ tone: "danger", title: copy.failed, subtitle: e instanceof Error ? e.message : String(e) });
    return false;
  }
}
